module.exports = __webpack_public_path__ + "img/grid-4.41ee6402.svg";